module.exports = __webpack_public_path__ + "static/media/fbb.6390dc3b.svg";